import { useTheme, TypographySizing } from '@ux/theme-utils';
import px2em from '@ux/px2em';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _SizeMap;
var SizeMap = (_SizeMap = {}, _defineProperty(_SizeMap, TypographySizing.SMALL, 48), _defineProperty(_SizeMap, TypographySizing.MEDIUM, 55), _defineProperty(_SizeMap, TypographySizing.LARGE, 63), _SizeMap);
var display = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap[theme.typography.sizing] || 55;
  return {
    fontSize: px2em(size),
    lineHeight: '1.14'
  };
});

// content is the same on any size scale
var content = (function () {
  return {
    fontSize: px2em(16),
    lineHeight: '1.5'
  };
});

// footnote is the same on any size scale
var footnote = (function () {
  return {
    fontSize: px2em(14),
    lineHeight: '1.5'
  };
});

// smallprint is the same on any size scale
var smallprint = (function () {
  return {
    fontSize: px2em(12),
    lineHeight: '1.5'
  };
});

var _SizeMap$1;
var SizeMap$1 = (_SizeMap$1 = {}, _defineProperty(_SizeMap$1, TypographySizing.SMALL, 32), _defineProperty(_SizeMap$1, TypographySizing.MEDIUM, 36), _defineProperty(_SizeMap$1, TypographySizing.LARGE, 42), _SizeMap$1);
var headingXxl = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$1[theme.typography.sizing] || 36;
  return {
    fontSize: px2em(size),
    lineHeight: '1.2'
  };
});

var _SizeMap$2;
var SizeMap$2 = (_SizeMap$2 = {}, _defineProperty(_SizeMap$2, TypographySizing.SMALL, 28), _defineProperty(_SizeMap$2, TypographySizing.MEDIUM, 32), _defineProperty(_SizeMap$2, TypographySizing.LARGE, 36), _SizeMap$2);
var headingXl = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$2[theme.typography.sizing] || 32;
  return {
    fontSize: px2em(size),
    lineHeight: '1.2'
  };
});

var _SizeMap$3;
var SizeMap$3 = (_SizeMap$3 = {}, _defineProperty(_SizeMap$3, TypographySizing.SMALL, 24), _defineProperty(_SizeMap$3, TypographySizing.MEDIUM, 28), _defineProperty(_SizeMap$3, TypographySizing.LARGE, 32), _SizeMap$3);

var LineHeightMap = _defineProperty({}, TypographySizing.SMALL, '1.25');

var headingL = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$3[theme.typography.sizing] || 28;
  var height = LineHeightMap[theme.typography.sizing] || '1.2';
  return {
    fontSize: px2em(size),
    lineHeight: height
  };
});

var _SizeMap$4, _LineHeightMap;
var SizeMap$4 = (_SizeMap$4 = {}, _defineProperty(_SizeMap$4, TypographySizing.SMALL, 21), _defineProperty(_SizeMap$4, TypographySizing.MEDIUM, 24), _defineProperty(_SizeMap$4, TypographySizing.LARGE, 28), _SizeMap$4);
var LineHeightMap$1 = (_LineHeightMap = {}, _defineProperty(_LineHeightMap, TypographySizing.SMALL, '1.3'), _defineProperty(_LineHeightMap, TypographySizing.MEDIUM, '1.25'), _defineProperty(_LineHeightMap, TypographySizing.LARGE, '1.2'), _LineHeightMap);
var headingM = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$4[theme.typography.sizing] || 24;
  var height = LineHeightMap$1[theme.typography.sizing] || '1.25';
  return {
    fontSize: px2em(size),
    lineHeight: height
  };
});

var _SizeMap$5;
var SizeMap$5 = (_SizeMap$5 = {}, _defineProperty(_SizeMap$5, TypographySizing.SMALL, 18), _defineProperty(_SizeMap$5, TypographySizing.MEDIUM, 21), _defineProperty(_SizeMap$5, TypographySizing.LARGE, 24), _SizeMap$5);

var LineHeightMap$2 = _defineProperty({}, TypographySizing.LARGE, '1.25');

var headingS = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$5[theme.typography.sizing] || 21;
  var height = LineHeightMap$2[theme.typography.sizing] || '1.3';
  return {
    fontSize: px2em(size),
    lineHeight: height
  };
});

var _SizeMap$6;
var SizeMap$6 = (_SizeMap$6 = {}, _defineProperty(_SizeMap$6, TypographySizing.SMALL, 16), _defineProperty(_SizeMap$6, TypographySizing.MEDIUM, 18), _defineProperty(_SizeMap$6, TypographySizing.LARGE, 21), _SizeMap$6);

var LineHeightMap$3 = _defineProperty({}, TypographySizing.SMALL, '1.5');

var headingXs = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$6[theme.typography.sizing] || 18;
  var height = LineHeightMap$3[theme.typography.sizing] || '1.3';
  return {
    fontSize: px2em(size),
    lineHeight: height
  };
});

var _SizeMap$7;
var SizeMap$7 = (_SizeMap$7 = {}, _defineProperty(_SizeMap$7, TypographySizing.SMALL, 14), _defineProperty(_SizeMap$7, TypographySizing.MEDIUM, 16), _defineProperty(_SizeMap$7, TypographySizing.LARGE, 18), _SizeMap$7);

var LineHeightMap$4 = _defineProperty({}, TypographySizing.LARGE, '1.3');

var headingXxs = (function () {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var size = SizeMap$7[theme.typography.sizing] || 16;
  var height = LineHeightMap$4[theme.typography.sizing] || '1.5';
  return {
    fontSize: px2em(size),
    lineHeight: height
  };
});

export { content, display, footnote, headingL, headingM, headingS, headingXl, headingXs, headingXxl, headingXxs, smallprint };
